var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('a',{staticClass:"btn btn-lg",attrs:{"href":_vm.link,"id":"upgrade-button","data-testid":"upgrade-button"}},[_vm._v("\n  Upgrade\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }